var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{attrs:{"type":"classic","config":_vm.editorConfig,"editor":_vm.editor},model:{value:(_vm.conteudo),callback:function ($$v) {_vm.conteudo=$$v},expression:"conteudo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }